import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useColorMode,
  Text,
  VStack,
  Grid,
  Image,
  Link,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward, faGift } from '@fortawesome/free-solid-svg-icons';
import { ThemedDonateButton } from '../../theme/ThemedDonateButton';

const supportersData = [
  { username: 'PlebUnderground', link: 'https://x.com/PlebUnderground' },
  { username: 'Meditation_Man', link: 'https://x.com/Meditation_Man' },
  { username: 'honesthodl', link: 'https://x.com/honesthodl' },
  { username: 'brian_trollz', link: 'https://x.com/brian_trollz' },
  { username: 'rwawoe', link: 'https://x.com/rwawoe' },
  { username: 'Coinicarus', link: 'https://x.com/Coinicarus' },
  { username: 'HumbleWarrior', link: 'https://x.com/HumbleWarrior' },
  { username: 'AEHW1', link: 'https://x.com/AEHW1' },
  { username: 'S0cratesz', link: 'https://x.com/S0cratesz' },
  { username: 'illiteratewithd', link: 'https://x.com/illiteratewithd' },
  { username: 'level39', link: 'https://x.com/level39' },
  { username: 'Producer_Jacob', link: 'https://x.com/Producer_Jacob' },
  { username: 'SADAMAFL', link: 'https://x.com/SADAMAFL' },
  { username: 'kavanhak', link: 'https://x.com/kavanhak' },
  { username: 'alexstanczyk', link: 'https://x.com/alexstanczyk' },
  { username: 'TimechainCaL', link: 'https://x.com/TimechainCaL' },
  { username: 'jerimican5445', link: 'https://x.com/jerimican5445' },
  { username: 'BTCsessions', link: 'https://x.com/BTCsessions' },
  { username: 'RustinPeace_SB', link: 'https://x.com/RustinPeace_SB' },
  { username: 'JaimeWGarcia', link: 'https://x.com/JaimeWGarcia' },
  { username: 'Florida_Btc', link: 'https://x.com/Florida_Btc' },
  { username: 'Clashdaddy69', link: 'https://x.com/Clashdaddy69' },
  { username: 'VailshireCap_JR', link: 'https://x.com/VailshireCap_JR' },
  { username: 'TomTaberHODL', link: 'https://x.com/TomTaberHODL' },
  { username: 'Train_Johnson', link: 'https://x.com/Train_Johnson' },
];

const Supporter = ({ link, username, imageKey }) => {
  // Use custom image for honesthodl
  const imageSrc = username === 'honesthodl' 
    ? 'https://pbs.twimg.com/profile_images/1801499602333360128/56KJXp3e_400x400.jpg'
    : `https://unavatar.io/twitter/${username}`;
  
  return (
    <Link href={link} target={'_blank'}>
      <Image
        key={imageKey}
        width="65px"
        height="65px"
        borderRadius={40}
        border={'2px'}
        borderColor={'gray.700'}
        objectFit="cover"
        src={imageSrc}
        alt={`@${username}`}
        fallbackSrc="https://www.gravatar.com/avatar/?d=mp&s=200"
      />
    </Link>
  );
};

const SupportersGrid = ({ supporters, imageKey }) => (
  <Grid templateColumns={{ base: "repeat(4, 1fr)", md: "repeat(5, 1fr)" }} gap={{ base: 6, md: 9 }}>
    {supporters.map((supporter, index) => (
      <Supporter key={index} {...supporter} imageKey={imageKey} />
    ))}
  </Grid>
);

export const SupportersModal = ({ isOpen, onClose, onBecomeSupporter }) => {
  const { colorMode } = useColorMode();
  const bgColor = colorMode === 'dark' ? '#121212' : '#ffffff';
  const borderColor = colorMode === 'dark' ? '#ffffff' : '#121212';

  const [randomizedSupporters, setRandomizedSupporters] = React.useState([]);
  const [imageKey, setImageKey] = React.useState(0);

  React.useEffect(() => {
    if (isOpen) {
      const shuffledSupporters = [...supportersData].slice(10); // Slice first 10
      shuffledSupporters.sort(() => Math.random() - 0.5); // Random sort
      setRandomizedSupporters([...supportersData.slice(0, 10), ...shuffledSupporters]);
      // Force images to reload when modal opens
      setImageKey(prev => prev + 1);
    }
  }, [isOpen]); // Add isOpen to dependency array

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: "2xl", md: "2xl" }}>
      <ModalOverlay backgroundColor="rgba(16, 22, 26, 0.9)" />
      <ModalContent bg={bgColor} pb={6} borderWidth="2px" borderStyle="solid" borderColor={borderColor} borderRadius="6px" overflow="hidden">
        <ModalHeader textAlign="center"><FontAwesomeIcon icon={faGift} size={'lg'} /> &nbsp;Support TimechainStats</ModalHeader>
        <ModalCloseButton
          _hover={{
            bg: 'gray.500',
          }}
          _focus={{
            boxShadow: '0 0 0 1px rgba(66, 153, 225, 0.6)',
          }}
        />
        <ModalBody px={20} pb={25}>
          <VStack spacing={5} align="center">
            <Text mb={4} textAlign="center">TimechainStats is a free data resource and is made possible in part with help from our generous Supporters.</Text>
            <ThemedDonateButton onClick={onBecomeSupporter} size={'xl'} px={'8px'} fontSize={'12px'}>
              <FontAwesomeIcon icon={faAward} size={'lg'} /> &nbsp;Become a Supporter
            </ThemedDonateButton>
            <Text textAlign="center" fontSize={'xl'} fontWeight={'bold'} pt={7} pb={3}>TimechainStats Supporters</Text>
            <SupportersGrid supporters={randomizedSupporters} imageKey={imageKey} />
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};